/**
 * Code calls
 */
export const getModules = 'billing/getModules';
export const addVoucher = 'billing/addVoucher';
